import { routeGuard } from "../../../router/guard";

export default [
	{
    path: "/dashboard",
    name: "Dashboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/romaneios",
    name: "Romaneios",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Romaneios.vue"),
  },
  {
    path: "/conferencia",
    name: "Conferencia",
    props: { homepage: true},
    //beforeEnter: routeGuard,
    component: () => import("../views/Conferencia.vue"),
  },
];
